import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatDivider } from '@angular/material/divider'
import { MatListModule } from '@angular/material/list'
import {
  FieldMapping,
  IngredientCsvTemplate,
} from '../../../../../types/csvTemplates'
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet'
import { Router } from '@angular/router'
import { TranslationService } from '../../../../../services/translation.service'

@Component({
  selector: 'app-ingredient-field-mapping-sheet',
  imports: [MatListModule, MatDivider],
  templateUrl: './ingredient-field-mapping-sheet.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ingredient-field-mapping-sheet.component.scss',
})
export class IngredientFieldMappingSheetComponent {
  data = inject(MAT_BOTTOM_SHEET_DATA)
  router = inject(Router)
  translationService = inject(TranslationService)

  private _bottomSheetRef =
    inject<MatBottomSheetRef<IngredientFieldMappingSheetComponent>>(
      MatBottomSheetRef,
    )

  csvTemplate?: IngredientCsvTemplate
  fields: Array<FieldMapping> = []
  // the object injected below has to be any since 'data' is dynamic

  constructor() {
    const data = this.data

    if (data.csvTemplate) {
      this.csvTemplate = data.csvTemplate
      this.fields = this.mapCsvTemplateToFieldMappings(data.csvTemplate)
    }
  }

  /**
   * Handles the `keydown` event for keyboard navigation.
   * Allows navigating the list using arrow keys and selecting items with Enter.
   *
   * @param {KeyboardEvent} event - The keyboard event triggered when a key is pressed down.
   * @param {number} index - The current index of the focused list item.
   */
  onKeydown(event: KeyboardEvent, index: number): void {
    const listItems = document.querySelectorAll('a[mat-list-item]')

    if (event.key === 'ArrowDown') {
      // Prevent default scroll behavior
      event.preventDefault()

      // Focus the next item, if it exists
      if (index < listItems.length - 1)
        (listItems[index + 1] as HTMLElement).focus()
    } else if (event.key === 'ArrowUp') {
      // Prevent default scroll behavior
      event.preventDefault()

      // If the current index is greater than 0, focus on the previous item
      if (index > 0) (listItems[index - 1] as HTMLElement).focus()
    }
  }

  mapCsvTemplateToFieldMappings(
    template: IngredientCsvTemplate,
  ): FieldMapping[] {
    return [
      { systemField: 'Name', alias: template.name },
      { systemField: 'Other Names', alias: template.otherNames },
      {
        systemField: 'CAS Numbers',
        alias: template.casNumbers,
      },
    ]
  }
}
